export const ADD_STUDENT_MODAL_SET_OPEN = 'ADD_STUDENT_MODAL_SET_OPEN';
export const ADD_STUDENT_MODAL_SET_ERROR = 'ADD_STUDENT_MODAL_SET_ERROR';
